import _ from "lodash";
import {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useContext,
} from "react";
import useFetch from "../../utils/useFetch";
import SectionTemplate from "../SectionTemplate";
import LoadingSpinner from "../../toolkit/LoadingSpinner";
import ErrorAlert from "../../toolkit/ErrorAlert";
import Introduction from "../Questionnaire/Introduction/Introduction";
import BaseURL from "../../utils/base-uri.json";
import ProgressBar from "../ProgressBar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";

import {
  Box,
  Grid,
  Menu,
  MenuItem,
  Button as Button1,
  CircularProgress,
} from "@mui/material";
import PlusIcon from "../../icons/PlusIcon";
import useMediaQuery from "@mui/material/useMediaQuery";

import Button from "../../toolkit/ButtonV1";

import ChecklistSubSectionlist from "./ChecklistSubSectionlist";
import ChecklistSectionTemplate from "./ChecklistSectionTemplate";
import ChecklistSectionDialog from "./dialogs/ChecklistSectionDialog";
import Visibility from "@mui/icons-material/Visibility";
import axios from "../../utils/fvAxios";
import { toast } from "react-toastify";
import { ChecklistContext } from "../../../src/store/checklist-context";
import RearrangeSubSectionList from "../CollectionsTemplate/re-arrange/RearrangeSubSectionList";
import ExcelIcon from "../../icons/Excel.svg";
import { t } from "i18next";
import fileDownload from "js-file-download";
import Delayed from "../../utils/Delayed";

const toastNotify = (message, isSuccess = true, isInfo = false) => {
  if (isInfo) {
    toast.info(message, {
      position: "top-right",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

function mapInitialData(r) {
  return {
    id: r.checklistSectionId,
    text: r.sectionName,
    status: r.isSectionCompleted === true ? "completed" : "pending",
    sectionType: r.sectionType,
    forChecklist: true,
    isVisible: r.isVisible,
    displayOrder: r.displayOrder,
    // metrics:
    //   r.sectionQuestions === 0
    //     ? null
    //     : r.sectionQuestionsCompleted + "/" + r.sectionQuestions,
    component: r.component,
    // IsSectionCompleted: r.isSectionCompleted,
    // HeaderTitle: r.sectionHeaderTitle,
    // FooterTitle: r.sectionFooterTitle,
    // HeaderContent: r.sectionHeader,
    // FooterContent: r.sectionFooter,
  };
}

function getComponent(name) {
  switch (name) {
    case 31:
    case 0:
      return Introduction;
    default:
      return ChecklistSubSectionlist;
  }
}

const params = new URLSearchParams(window.location.search);
const TemplateId = params.get("t");
export default function ChecklistSectionList({
  dataUrl,
  selected,
  PQSTID,
  ViewMode,
  PQCLIENTID,
  ClientTemplate,
  templateId,
  reorderSections,
}) {
  const _templateId = templateId ?? TemplateId;

  const [error, setError] = useState(true);
  const [loading, setLoading] = useState(true);
  const [hasUserInputs, setHasUserInputs] = useState(false);
  const [uploadErrors, setUploadErrors] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const checklistContext = useContext(ChecklistContext);

  const closeErrorPopup = () => {
    setOpenDialog(false);
    setTimeout(() => {
      setUploadErrors(null);      
    }, 200);
  };

  const getChecklistSections = () => {
    setLoading(true);
    axios
      .get(
        BaseURL.templateTool.GetChecklistSections + "templateId=" + templateId
      )
      .then((res) => {
        if (res?.data?.status == false) {
          setError(true);
          console.error(res?.data);
          return;
        }
        error && setError(false);

        let _sections = res.data?.data?.sections?.forEach(
          (q) => (q.component = getComponent(q.sectionType))
        );

        setHasUserInputs(res.data?.data?.hasUserInputs);
        _sections = res?.data.data?.sections?.map(mapInitialData) || [];
        const addNew = {
          id: 0,
          text: "Add New",
          status: "pending",
          sectionType: "",
          forChecklist: true,
        };
        if (_sections.filter((value) => value.id > 0)?.length > 0)
          _sections.push(addNew);
        setSections(_sections);
        setSectionId(_sections?.[0]?.id)
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const [sections, setSections] = useState([]);
  const [sectionId, setSectionId] = useState(selected);
  const [section, setSection] = useState();
  const [navProps, setNavProps] = useState({
    options: sections,
    onChange: (sectionId) => {
      setSection(null);
      setSectionId(sectionId);
    },
    variant: "stepperNav",
  });

  const [allowReorder, setAllowReorder] = useState(false);
  const [temporarycollection, setTemporaryCollection] = useState([]);

  const [sectionDialogOpen, setSectionDialogOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleDialogClose = (isSavedSuccessfuly) => {
    setSectionDialogOpen(false);
    if (isSavedSuccessfuly === true) {
      //setSection(null);
      // setSectionId(sectionId);
      // setRefresh(!refresh);
      getChecklistSections();
    } else setSectionId(sections?.[0]?.id);
  };

  const SaveReorder = () => {
    axios
      .post(
        BaseURL.templateTool.ReorderCheckListSubSections,
        temporarycollection.map((item, index) => ({
          ...item,
          checklistSubSectionId: item.id,
        }))
      )
      .then((response) => {
        setAllowReorder(false);
      });
  };
  const cancelReoder = () => {
    setAllowReorder(false);
    setTemporaryCollection([]);
  };

  const addOrUpdateSection = (id) => {
    if (id == -1) return;
    if (id > 0) {
      setSectionDialogOpen(true);
    } else setSectionId(0);
  };
  const refreshSectionList = (id) => {
    checklistContext.setSectionIdGlobal(sectionId);
    getChecklistSections();
  };
  const handleReorderSections = () => {
    reorderSections(sections.filter((value) => value.id > 0));
  };

  useEffect(() => {
    if (
      sectionId == 0
      // &&  sections?.filter((value) => value.id > 0)?.length > 0
    ) {
      setSectionDialogOpen(true);
      return;
    }
    if (sectionId > 0) checklistContext.setSectionIdGlobal(sectionId);
    setSection(sections.find((s) => s.id === sectionId));
  }, [sectionId]);

  useLayoutEffect(() => {
    setSectionId(
      checklistContext.sectionIdGlobal > 0
        ? checklistContext.sectionIdGlobal
        : sections?.[0]?.id
    );
  }, [navProps]);

  useEffect(() => {
    setNavProps((prev) => ({
      ...prev,
      options: sections,
    }));
    if (sectionId > 0) setSection(sections.find((s) => s.id === sectionId));
  }, [sections]);

  useEffect(() => {
    getChecklistSections();
  }, []);

  function setNextActive() {
    const cur = sections.find((f) => f.id === section.id);
    const next = sections[sections.indexOf(cur) + 1];
    if (next) {
      setSectionId(next.id);
    }
  }
  const reorderSubSections = (data) => {
    setTemporaryCollection(
      data?.map((item, index) => ({
        ...item,
        displayOrder: index + 1,
      }))
    );
    setAllowReorder(true);
  };
  const onDataReorder = (data) => {
    setTemporaryCollection(data);
  };

  const ITEM_HEIGHT = 50;
  const [anchorEl, setAnchorEl] = useState(null);
  let open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const fileInputRef = useRef(null);
  const handleFileChange = (e) => {
    handleClose();
    const selectedFile = e.target.files[0];

    // Check if a file is selected
    if (selectedFile) {
      // Get the file extension
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

      // Check if the file extension is valid for Excel files
      if (fileExtension === "xls" || fileExtension === "xlsx") {

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("templateId", templateId);
        setIsUploading(true);
        axios
          .post(
            BaseURL.baseUrl + BaseURL.templateTool.BulkChecklistDataInsert,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((response) => {
            const _data = response.data?.data;
            if (
              response.data?.responseMessage === "Success" &&
              _data?.message == "Success"
            ) {
              if (_data) {
                toastNotify(response.data?.responseMessage);
                getChecklistSections();
              }
            } else if (_data?.errors.length > 0) {
              setUploadErrors(_data?.errors);
               setOpenDialog(true);
            } else {
              toastNotify(_data?.message ?? response.data?.responseMessage, false);
            }
          })
          .catch((e) => {
            toastNotify("Error in Uploading", false);
          })
          .finally(() => {
            setIsUploading(false);
          });
      } else {
        alert("Invalid file type. Please select an Excel file.");
        console.error("Invalid file type. Please select an Excel file.");
      }
    }
  };

  const handleExport = () => {
    axios
      .get(
        BaseURL.baseUrl +
          BaseURL.templateTool.DownloadChecklistSample +
          "fileName=ChecklistTemplateSample",
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        fileDownload(res?.data, "ChecklistTemplateSample.xlsx");
        handleClose();
      });
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <ErrorAlert severity="error" message={error} />
      ) : (
        <>
          <Dialog fullScreen={fullScreen} open={openDialog} onClose={closeErrorPopup}>
            <DialogContent sx={{ padding: "40px 48px" }}>
              <DialogTitle
                sx={{
                  textAlign: "center",
                  fontWeight: 500,
                  fontSize: 20,
                }}
              >
                Errors
              </DialogTitle>

              {/* <ErrorAlert
                className="border d-none"
                severity="error"
                 message={`${
                  uploadErrors?.length ?? "Data upload Unsuccessful"
                }`}
              /> */}
              {/* <ul> */}
              {uploadErrors?.map((error, index) => (
                // <li key={index}>
                <div key={index} className="p-0 mt-1">
                  <ErrorAlert severity="error" message={`${error}`} />
                </div>
                // </li>
              ))}
              {/* </ul> */}

              <DialogActions>
                <div className="d-flex justify-content-end login-help__buttonContainer mt-4">
                  <Button1
                    variant="contained"
                    className="login-button-request mx-2"
                    onClick={closeErrorPopup}
                  >
                    Ok
                  </Button1>
                </div>
              </DialogActions>
            </DialogContent>
          </Dialog>
          <>
            <div className="d-flex justify-content-between my-2">
              <Button
                sx={{ minWidth: "130px" }}
                role="secondary"
                size="large"
                label="Re-Arrange"
                onClick={handleReorderSections}
              />
              <div className="d-flex justify-content-between">
                {isUploading && (
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Box>
                )}
                <span className="pe-2 text-right" onClick={handleClick}>
                  <img src={ExcelIcon} alt="excel" style={{ width: "40%" }} />

                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      "aria-labelledby": "long-button",
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={(e) => {
                      e.stopPropagation();
                      handleClose();
                    }}
                    PaperProps={{
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: "30ch",
                      },
                    }}
                  >
                    <MenuItem
                      disabled={hasUserInputs}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <label
                        style={{
                          textDecoration: "none",
                          cursor: "pointer",
                          color: "black",
                        }}
                      >
                        {t("SampleFormat.import")}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                          accept=".xls, .xlsx"
                        />
                      </label>
                    </MenuItem>
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        handleExport();
                      }}
                    >
                      <a
                        style={{
                          textDecoration: "none",
                          cursor: "pointer",
                          color: "black",
                        }}
                      >
                        {t("SampleFormat.export")}
                      </a>
                    </MenuItem>
                  </Menu>
                </span>

                <Button
                  role="primary"
                  size="default"
                  label="Add Checklist Section"
                  onClick={() => addOrUpdateSection(0)}
                  trailingComponent={<PlusIcon />}
                  className="mt-1"
                />
              </div>
            </div>
            <Delayed waitBeforeShow={100}>
              <ChecklistSectionTemplate
                navWrapper={true}
                leftLabel={""}
                rightLabel={""}
                navProps={{
                  ...navProps,
                  selected: sectionId,
                }}
                addOrUpdateSection={addOrUpdateSection}
                refreshSectionList={refreshSectionList}
              >
                {section?.id ? (
                  section?.isVisible ? (
                    allowReorder ? (
                      <>
                        <Grid
                          container
                          wrap="nowrap"
                          sx={{
                            flexDirection: {
                              xs: "column",
                              md: "row",
                            },
                          }}
                          spacing={1}
                          justify="flex-start"
                        >
                          <Grid item sx={{ margin: "auto" }}>
                            <Grid
                              container
                              className="text-align-center"
                              wrap="nowrap"
                              sx={{
                                flexDirection: {
                                  xs: "column",
                                  md: "row",
                                  overflow: "auto",
                                },
                              }}
                              spacing={1}
                            >
                              <Grid item>
                                <Button
                                  sx={{ minWidth: "130px" }}
                                  role="secondary"
                                  size="large"
                                  label="Cancel"
                                  onClick={cancelReoder}
                                />
                              </Grid>
                              <Grid item>
                                <Button
                                  sx={{ minWidth: "130px" }}
                                  role="secondary"
                                  size="large"
                                  label="Done"
                                  onClick={SaveReorder}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <RearrangeSubSectionList
                          rows={temporarycollection}
                          onDataReorder={onDataReorder}
                        />
                      </>
                    ) : (
                      <div style={{ minHeight: "800px" }}>
                        <Delayed waitBeforeShow={500}>
                          <ChecklistSubSectionlist
                            IsSectionCompleted={section?.IsSectionCompleted}
                            dataUrl={section ? `${dataUrl}/${section?.id}` : ""}
                            Secid={section?.id}
                            SectionType={section?.sectionType}
                            setNextSection={setNextActive}
                            PqStatusID={PQSTID}
                            VIEWMODE={ViewMode}
                            PQCLIENTID={PQCLIENTID}
                            ClientTemplate={ClientTemplate}
                            refreshSectionList={refreshSectionList}
                            reorderSubSections={reorderSubSections}
                            isParent={true}
                            />
                          </Delayed>
                      </div>
                    )
                  ) : (
                    <div className="rounded p-3 px-4 border d-block text-align-center">
                      <h3>{section?.text} is Hidden</h3>
                      <p className="mb-2">
                        Change Visibility using <Visibility color="disabled" />{" "}
                        icon
                      </p>
                    </div>
                  )
                ) : null}
              </ChecklistSectionTemplate>
            </Delayed>
            </>

          {sectionDialogOpen && (
            <ChecklistSectionDialog
              setEditDialogOpen={setSectionDialogOpen}
              handleDialogClose={handleDialogClose}
              checklistSectionId={sectionId}
              templateId={templateId}
              currentSectionsCount={sections.length}
            />
          )}
        </>
      )}
    </>
  );
}
